var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.editable && !_vm.disabled,
              expression: "editable&&!disabled",
            },
          ],
          staticClass: "internalActionDiv",
        },
        [
          _c(
            "q-btn-group",
            { attrs: { outline: "" } },
            [
              _c("c-btn", {
                attrs: {
                  isSubmit: _vm.isComplete,
                  url: _vm.completeUrl,
                  param: _vm.targetDept,
                  mappingType: "PUT",
                  label: "LBL0010136",
                  icon: "check",
                },
                on: {
                  beforeAction: _vm.completeAction,
                  btnCallback: _vm.completeActionCallback,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-tab", {
        attrs: {
          type: "horizon",
          tabItems: _vm.tabItems,
          inlineLabel: true,
          dense: true,
          height: _vm.tabHeight,
        },
        on: {
          "update:tabItems": function ($event) {
            _vm.tabItems = $event
          },
          "update:tab-items": function ($event) {
            _vm.tabItems = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    popupParam: _vm.popupParam,
                    targetDept: _vm.targetDept,
                    imprTabInfo: _vm.imprTabInfo,
                    disabled: _vm.disabled,
                    contentHeight: _vm.contentHeight,
                  },
                  on: {
                    "update:targetDept": function ($event) {
                      _vm.targetDept = $event
                    },
                    "update:target-dept": function ($event) {
                      _vm.targetDept = $event
                    },
                    "update:imprTabInfo": function ($event) {
                      _vm.imprTabInfo = $event
                    },
                    "update:impr-tab-info": function ($event) {
                      _vm.imprTabInfo = $event
                    },
                    "update:disabled": function ($event) {
                      _vm.disabled = $event
                    },
                    getDetail: _vm.getDetail,
                    stepup: _vm.stepup,
                    setRegInfo: _vm.setRegInfo,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }